export default "__VITE_ASSET__91fec9cb__"